import { useHistory, useLocation } from "react-router-dom";
import { storage } from "./firebase";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "./providers/UserProvider";

export default function UpdateEvent({ object }) {
    const history = useHistory();
    const location = useLocation();

    const collection = object.ref.parent.id;

    return <div className="mb-3 flex">
        <ReferenceImage reference={object.data().image} />
        <div className="p-3 bg-gray-300 flex flex-1" style={{borderRadius: "0px 5px 5px 0px"}}>
            <div className="flex-1 flex flex-col justify-between">
                <div>
                    <div className="text-lg font-semibold">{object.data().name}</div>
                    <div className="text-sm">{object.data().venue_data?.name}</div>
                    <div className="text-sm">{object.data().start?.toDate()?.toLocaleDateString('de-DE', {year: 'numeric', month: 'long', day: 'numeric'})}</div>
                </div>
                <div className="flex flex-col">
                    <div className="text-sm">Hinzugefügt am: {object.data().created_timestamp?.toDate().toLocaleString('de-DE')}</div>
                    <div className="text-sm">Hinzugefügt von: {(() => {
                        switch(object.data().created_by) {
                            case 'event-form':
                                return 'Formular';
                            default:
                                return 'Admin';
                        }
                    })()}</div>
                </div>
            </div>
            <div className="flex flex-col gap-2 justify-center">
                <button className="bg-white p-2 rounded cursor-pointer" onClick={() => history.push(`/${collection}/${object.id}?return=${encodeURIComponent(location.pathname + location.search)}`)}>Anzeigen</button>
                <button className="b-yellow p-2 px-3.5 rounded cursor-pointer" onClick={() => history.push(`/${collection}/${object.id}/share?return=${encodeURIComponent(location.pathname + location.search)}`)}>Zur Grafik</button>
            </div>
        </div>
    </div>;
}

function ReferenceImage({reference}) {
    const [url, setUrl] = useState('data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');

    useEffect(() => reference ? storage.ref(reference).getDownloadURL().then(url => setUrl(url)).catch(_ => setUrl('data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==')) : null, [reference]);

    return <img className="w-60 h-40 object-cover" style={{borderRadius: "5px 0px 0px 5px"}} src={url} alt="" />;
}